import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'
import { toast } from 'react-toastify'
import { GLOBAL_ERROR } from '../../../constants/translations/error'
import { useTranslation } from 'react-i18next'
import { AggregationLevel, Channel } from '../home.model'

export interface UseApiPostTargetProductivityRequest {
  channel: Channel
  aggregation: AggregationLevel
  storeId: number
  teamId: number | null
  targetProductivity: number | null
}

export interface TargetProductivity {
  value: number | null
}

const saveTargetProductivity = async (
  payload: UseApiPostTargetProductivityRequest,
  enabled: boolean
): Promise<TargetProductivity> => {
  if (!enabled) {
    return {
      value: undefined
    }
  }
  return await axios.post(`/instore-target-productivity`, payload).then(() => ({ value: payload.targetProductivity }))
}

export const useApiPostTargetProductivity = (args: UseApiPostTargetProductivityRequest, enabled: boolean) => {
  const { t } = useTranslation()
  const { storeId, teamId, channel, aggregation, targetProductivity } = args

  const payload: UseApiPostTargetProductivityRequest = {
    aggregation,
    channel,
    storeId,
    teamId,
    targetProductivity
  }
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      return saveTargetProductivity(payload, enabled)
    },
    onSuccess: response => {
      toast.info(t('target-productivity.save.success'))
      queryClient.setQueryData(['get-target-productivity', aggregation, channel, storeId, teamId], response)
    },
    onError: () => {
      toast.error(t(GLOBAL_ERROR))
    }
  })
}
